import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TicketCart } from '../../shared/models/components-general/card.model';

@Component({
  selector: 'app-card-request',
  imports: [MatIcon, MatButtonModule, CommonModule],
  templateUrl: './card-request.html',
  styleUrl: './card-request.css',
})
export class CardRequest {
  @Output() public deleteEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() public detailEvent: EventEmitter<void> = new EventEmitter<void>();
  @Input() public ticketSection: TicketCart | null = null;

  public onDelete() {
    this.deleteEvent.emit();
  }

  public onDetail() {
    this.detailEvent.emit();
  }
}
